/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import LocationAvailable from "../../../assets/images/Charger_active.png";
import LocationInuse from "../../../assets/images/location_in_use.png";
import LocationInactive from "../../../assets/images/Charger_inactive_1.png";
import BlueDotIcon from "../../../assets/images/location.png";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import "../Somecss.css";
import { darkMapStyle } from "../../../assets/data/Mapstyle.js";

const useCurrentLocation = () => {
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [error] = useState(null);

  useEffect(() => {
    localStorage.setItem("maploaded", "false");
    if (!navigator.geolocation) {
      setLocation({
        lat: 25.2048,
        lng: 55.2708,
      });
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, []);

  return { location, error };
};

const MapComponent = ({ locations, givenHeight, zoomLevel }) => {
  const [locations1, setLocations1] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    setLocations1(locations);
  }, [locations]);

  const { location: currentLocation, error } = useCurrentLocation();
  localStorage.setItem("Currentlocation", JSON.stringify(currentLocation));
  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [dubailoc] = useState({ lat: 25.2048, lng: 55.2708 });

  useEffect(() => {
    if (currentLocation.lat && currentLocation.lng) {
      setCenter(currentLocation);
    }
  }, [currentLocation]);

  const mapContainerStyle = {
    height: givenHeight || "50vh",
    width: "100%",
  };


  useEffect(() => {
    if (mapInstance && locations1.length > 0) {
      handleMapLoad(mapInstance);
    }
  }, [locations1, mapInstance]);



  const getGridOffset = (lat, lng, index) => {
    const spacing = 0.00004;
    const row = Math.floor(index / 3);
    const col = index % 5;

    return {
      lat: lat + (row * spacing),
      lng: lng + (col * spacing),
    };
  };


  const handleMapLoad = (map) => {
    localStorage.setItem("maploaded", "true");

    const markers = [];

    locations1.forEach((loc) => {
      const lat = loc?.direction?.latitude;
      const lng = loc?.direction?.longitude;

      const chargers = loc?.data?.chargerInfo || [];

      if (chargers.length === 0) {
        return;
      }

      chargers.forEach((charger, index) => {
        const chargerStatus = charger?.status 
      
        const icon =
          chargerStatus === "Active"
            ? { url: LocationAvailable, scaledSize: new window.google.maps.Size(25, 25) }
            : chargerStatus === "Charging"
              ? { url: LocationInuse, scaledSize: new window.google.maps.Size(25, 25) }
              : { url: LocationInactive, scaledSize: new window.google.maps.Size(25, 25) };

        const position = getGridOffset(lat, lng, index);

        const marker = new window.google.maps.Marker({
          position,
          icon,
          title: `${loc?.name} - ${charger?.chargerName || charger?.name || `Charger ${index + 1}`}`,
        });

        marker.addListener("click", () => handleMarkerClick(loc, charger));

        markers.push(marker);
      });
    });


    setIsMapLoaded(true);

    new MarkerClusterer({
      map,
      markers,
      renderer: {
        render({ count, position }) {
          return new window.google.maps.Marker({
            position,
            icon: {
              path: window.google.maps.SymbolPath.CIRCLE,
              fillColor: "#8c83cd",
              fillOpacity: 1,
              strokeColor: "#8c83cd",
              strokeWeight: 2,
              scale: 18,
            },
            label: {
              text: String(count),
              color: "black",
              fontSize: "14px",
            },
          });
        },
      },
    });
  };

  const handleMarkerClick = (loc, charger) => {
    setSelectedLocation({ ...loc, selectedCharger: charger });
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  const pop = (row_data) => {
    navigate("/location/view", { state: row_data?._id });
  };

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={dubailoc}
      zoom={zoomLevel || 11}
      onLoad={(map) => setMapInstance(map)}
      options={{
        styles: darkMapStyle,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_CENTER,
        },
        minZoom: 2,
      }}
    >
      {selectedLocation && (
        <InfoWindow
          position={{
            lat: selectedLocation?.direction?.latitude,
            lng: selectedLocation?.direction?.longitude,
          }}
          onCloseClick={() => setSelectedLocation(null)}
        >
          <div style={{ display: "flex", flexDirection: "column", width: "250px" }}>
            <h4 style={{ marginBottom: "0.25rem" }}>{selectedLocation?.name}</h4>
            <p style={{ margin: "0.25rem 0" }}>{selectedLocation?.data?.address}</p>
            {selectedLocation?.selectedCharger ? (
              <>
                <strong style={{ marginTop: "0.5rem" }}>
                  {selectedLocation.selectedCharger.name }
                </strong>
                <div style={{ fontSize: 13 }}>
                  <div>Status: {selectedLocation.selectedCharger.status || "Unknown"}</div>
                  <div>Type: {selectedLocation.selectedCharger.type || "-"}</div>
                </div>
              </>
            ) : (
              (selectedLocation?.data?.chargerInfo?.length > 0) && (
                <div style={{ marginTop: "0.5rem", maxHeight: 140, overflowY: "auto" }}>
                  {selectedLocation.data.chargerInfo.map((c, i) => (
                    <div key={c._id || i} style={{ fontSize: 13, marginBottom: 6 }}>
                      <strong>{c.chargerName || c.name || `Charger ${i + 1}`}</strong>
                      <div>Status: {c.status || "Unknown"}</div>
                    </div>
                  ))}
                </div>
              )
            )}

            <Button variant="text" onClick={() => pop(selectedLocation?.data)}>
              View Location
            </Button>
          </div>
        </InfoWindow>
      )}

      {isMapLoaded && (
        <Marker
          position={center}
          title="Current Location"
          icon={{
            url: BlueDotIcon,
            scaledSize: new window.google.maps.Size(25, 25),
          }}
        />
      )}
    </GoogleMap>
  );
};

export default MapComponent;
